import { useCallback } from 'react';
import { ClearCartResponse } from 'shared/types/checkout';
import { sdk } from 'sdk';
import { getAccountId, useAppSelector } from 'store';
import { withCookieValidation } from 'utils/edx-auth';

export const useClearCart = () => {
  const customerId = useAppSelector(getAccountId);

  const clearCart = useCallback(
    async () => {
      const response = await withCookieValidation(() =>
        sdk.callAction<ClearCartResponse>({
          actionName: 'cart/clearCart',
        }),
      );

      const error = response.isError
        ? response.error
        : response.data.isError
          ? response.data.error
          : null;

      if (error) {
        console.error(
          `Error in clearCart extension for customer: ${customerId} with error code: ${
            (error?.code as string) ?? ''
          } and error message: ${
            error?.message ?? JSON.stringify(error) ?? 'unknown'
          }`,
        );
      } else {
        console.info(`Cleared cart for customer: ${customerId}.`);
      }

      return response.isError ? response : response.data;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customerId],
  );

  return { clearCart };
};
